<template>
  <ul class="tick-off-list" v-if="$store.getters.isLoaded(['products', 'orders'])">
    <li
      v-for="(item, i) in items"
      :key="i"
      :class="{
        completed: item.amount - item.packed === 0 || item.partiallyAvailable,
        ['not-available']: item.notAvailable
      }"
      @click="$emit('item-clicked', i)"
    >
      <div
        :style="
          `background-image: url(https://storage.googleapis.com/emma-static/products/${
            product(item.productId).img
          }_256.jpg)`
        "
        class="tick-off-list__image"
      ></div>
      <span v-if="item.amount > 1 && !item.notAvailable" class="tick-off-list__amount"
        >{{ item.packed || 0 }} / {{ item.amount }}</span
      >
      <span v-if="item.boxSpaces.length !== 0 && item.amount - item.packed !== 0" class="tick-off-list__box-space">
        {{ item.boxSpaces[0].substr(3, 2) }}</span
      >
      <span
        v-if="product(item.productId).temporarilyUnavailable"
        class="tick-off-list__temporarily-unavailable badge badge-warning"
      >
        Zeit nicht verfügbar</span
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    product(productId) {
      return _.find(this.$store.state.products, { id: productId })
    }
  }
}
</script>

<style lang="scss" scoped>
.tick-off-list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;

  li {
    width: calc(33.333% - 1rem);
    display: inline-block;
    border: 3px #e8e8e8 solid;
    border-radius: 5px;
    padding: 1rem;
    margin: 0.5rem;
    position: relative;

    &.completed,
    &.not-available {
      border-color: transparent;
      &:after {
        border-radius: 5px;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    &.completed:after {
      background: rgba(lighten($color-success-green, 15%), 0.25);
    }
    &.not-available:after {
      background: rgba(lighten($color-alert-yellow, 15%), 0.25);
    }
  }

  &__image {
    width: 100%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;

    &:after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
  }

  &__amount {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    background: $color-alert-yellow;
    border-radius: 4px;
    padding: 0.5rem;
    font-weight: $weight-bold;
    font-size: 1.25rem;
  }

  &__box-space {
    background: #111;
    color: #fff;
    position: absolute;
    left: 0;
    font-size: 2rem;
    padding: 0 0.5rem;
    bottom: 1rem;
    border-radius: 0 5px 5px 0;
  }

  &__temporarily-unavailable {
    position: absolute;
    left: 0;
    font-size: 0.75rem;
    text-align: center;
    margin-top: 0.5rem;
  }
}
</style>
